import {
    LiteTradeNotificationAccountTypeContainerStyled,
    LiteTradeNotificationAccountTypeStyled,
    LiteTradeNotificationDescriptionStyled,
    LiteTradeNotificationStatusIconContainerStyled,
    LiteTradeNotificationStyled
} from "./styled/LiteTradeNotificationStyled";
import { BinIcon } from "../../../../components/icon/Icon";
import { LITE_TRADE_NOTIFICATION_STATUSES } from "./liteTradeNotificationConstants";
import { ACCOUNT_TYPES } from "../../../../app/appConstants";
import classNames from "classnames";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { getLiteTradeNotificationStatusByNotificationType } from "./liteTradeNotificationUtils";

function LiteTradeNotification(props) {
    const {
        accountType,
        children,
        description,
        status,
        symbol,
        type,
        withCloseButton = true,
    } = props;

    const {getLangPath} = useLangContext();
    const currentStatus = status || getLiteTradeNotificationStatusByNotificationType(type);

    return <LiteTradeNotificationStyled>
        <div className="d-flex align-items-center">
            <div className="d-flex flex-1 align-items-center">
                <LiteTradeNotificationStatusIconContainerStyled className={currentStatus}>
                    <BinIcon
                        name={currentStatus === LITE_TRADE_NOTIFICATION_STATUSES.SUCCESS ? "IcCheckMark" : "IcCircleSlashed"}/>
                </LiteTradeNotificationStatusIconContainerStyled>
                <div
                    className="ms-2 fw500 f16">{getLangPath(`lite_version.notifications.title.${type}`, {symbol})}</div>
            </div>
            <LiteTradeNotificationAccountTypeContainerStyled className={classNames({
                'with-close-button': withCloseButton
            })}>
                <LiteTradeNotificationAccountTypeStyled>
                    {accountType === ACCOUNT_TYPES.LIVE ? 'Real' : 'Demo'}
                </LiteTradeNotificationAccountTypeStyled>
            </LiteTradeNotificationAccountTypeContainerStyled>
        </div>
        {!!description && <LiteTradeNotificationDescriptionStyled className="mt-2">
            {description}
        </LiteTradeNotificationDescriptionStyled>}
        {!!children && children}
    </LiteTradeNotificationStyled>
}

export default LiteTradeNotification;
